import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';
var initialValue = {
  innerWidth: null,
  innerHeight: null,
  outerWidth: null,
  outerHeight: null
};
/**
 * useWindowSize
 *
 * A hook that provides information of the dimensions of the window
 *
 * @return {WindowDimensions}  Dimensions of the window
 */

function useWindowSize() {
  var _useState = useState(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      windowSize = _useState2[0],
      setWindowSize = _useState2[1];

  function fetchWindowDimensionsAndSave() {
    setWindowSize({
      innerWidth: window.innerWidth,
      innerHeight: window.innerHeight,
      outerWidth: window.outerWidth,
      outerHeight: window.outerHeight
    });
  } // run on mount


  useEffect(function () {
    // run only once
    fetchWindowDimensionsAndSave();
  }, []); // set resize handler once on mount and clean before unmount

  useEffect(function () {
    window.addEventListener("resize", fetchWindowDimensionsAndSave);
    return function () {
      window.removeEventListener("resize", fetchWindowDimensionsAndSave);
    };
  }, []);
  return windowSize;
}

export default useWindowSize;